import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import styles from './index.module.scss';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoTab, { EcoTabItemProps } from 'eco-design/elements/eco-tab';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoImg from 'eco-design/base/eco-img';
import { useEffect, useState } from 'react';
import { useMediaDevice } from '@elem/compPage/Oasis/hooks';
import EcoIconSwiperArrow from 'eco-design-micro/icons/eco-icon-swiper-arrow';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import 'swiper/scss';
import EfSection from '@elem/ui/ef-section';

interface ItemType {
    title: string;
    desc: string;
    pc: string;
    h5: string;
    icon: string;
}

const JH: React.FC = () => {
    const { t } = useLang('delta3series');
    const [active, setActive] = useState('0');
    const { isH5 } = useMediaDevice();
    const [spaceBetweenN, setSpaceBetweenN] = useState(24);

    const items: ItemType[] = [
        {
            icon: '',
            title: t('H_item1_title'),
            desc: t('H_item1_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1741058283050/D3P-%E5%8C%85%E8%A3%85-1%202%20(2).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1741058372119/D3P-%E5%8C%85%E8%A3%85-1%202%20(1).jpg',
        },
        {
            icon: '',
            title: t('H_item2_title'),
            desc: t('H_item2_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1741058283451/Mask%20group.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1741058371909/%E5%9B%BE%E7%89%87.jpg',
        },
        {
            icon: '',
            title: t('H_item3_title'),
            desc: t('H_item3_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1741058283244/Mask%20group%20(1)%20(1).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1741058371728/03.jpg',
        },
    ];

    const tabs: EcoTabItemProps[] = [
        {
            tabValue: '0',
            tabLabel: t('H_tab1'),
        },
        {
            tabValue: '1',
            tabLabel: t('H_tab2'),
        },
        {
            tabValue: '2',
            tabLabel: t('H_tab3'),
        },
    ];
    useEffect(() => {
        const initHandle = () => {
            const clientWidth = document.body.clientWidth;
            if (clientWidth >= 1024) {
                setSpaceBetweenN(24);
            } else {
                setSpaceBetweenN(16);
            }
        };
        initHandle();
    }, []);
    return (
        <div className={styles.comp} id="d3-H">
            <EcoSpace />
            <EfSection label={t('H_label')} title={t('H_title')} />
            <EcoSpaceSmall />
            {!isH5 && (
                <div className="box">
                    <div className="inner">
                        <div className="img-box">
                            <EcoImg pc={items[Number(active)].pc} pad={items[Number(active)].pc} h5={items[Number(active)].h5} />
                        </div>
                        <div className="info">
                            <p className="title">{items[Number(active)].title}</p>
                            <p className="desc">{items[Number(active)].desc}</p>
                        </div>
                    </div>
                </div>
            )}
            {!isH5 && <EcoTab items={tabs} onChange={(item: EcoTabItemProps) => setActive(item.tabValue)} />}
            {isH5 && (
                <div className="box">
                    <Swiper
                        slidesPerView={'auto'}
                        spaceBetween={spaceBetweenN}
                        navigation={{
                            nextEl: '.eco-swiper-button-next',
                            prevEl: '.eco-swiper-button-prev',
                        }}
                        modules={[Navigation]}
                    >
                        {items.map((carouselItem, index: number) => {
                            return (
                                <SwiperSlide key={index} className={`box-item`}>
                                    <div className="inner">
                                        <div className="img-box">
                                            <EcoImg pc={carouselItem.pc} pad={carouselItem.pc} h5={carouselItem.h5} />
                                        </div>
                                        <div className="info">
                                            <p className="title">{carouselItem.title}</p>
                                            <p className="desc">{carouselItem.desc}</p>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                        <div className={`eco-swiper-control eco-swiper-control-black`}>
                            <div className="eco-swiper-navigation">
                                <div className="eco-swiper-button-prev">
                                    <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                                </div>
                                <div className="eco-swiper-button-next">
                                    <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                                </div>
                            </div>
                        </div>
                    </Swiper>
                </div>
            )}
        </div>
    );
};

export default JH;
